export default __webpack_public_path__ + "static/media/Qsehra-benefit-design-icon 1.4cb7b4ab.svg";